function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRoomSmokingFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.755 11.48c-2.955 0-5.359-2.234-5.359-4.979h-2c0 3.848 3.301 6.978 7.36 6.978 1.208 0 2.192.898 2.192 2.002h2c0-2.207-1.88-4.002-4.193-4.002zm5.193 4.002c0-2.745-2.404-4.978-5.359-4.978-2.313 0-4.193-1.795-4.193-4.002h2c0 1.104.984 2.002 2.193 2.002 4.058 0 7.36 3.13 7.36 6.978h-2zM24.95 25.5h2v-8h-2v8zm3 0h2v-8h-2v8zm-5-6H4.052v4h18.897v2H3.052a1 1 0 01-1-1v-6a1 1 0 011-1h19.897v2z",
    fill: props.color
  }));
}

export default SvgIconRoomSmokingFilled;